module.exports = __webpack_public_path__ + "static/media/third_declension2_img.46e7e2cf.JPG";